/**
 * OrganizerAlerts.js
 * ─────────────────────────────────────────────────────────────────────────────
 * The event organizer's "Alerts" screen. Organizers have no profile / settings
 * tab of their own (their sidebar is Dashboard, My Events, Scanner, My Team,
 * Activity Log), so the shared Alert settings panel gets a page of its own in
 * the Ticketing group, dressed in the same pbi Page / Hero / Panel shell as the
 * rest of the ticketing screens.
 *
 * Two sections:
 *   1. Alert settings: email / SMS / WhatsApp channels, alert contacts, what to
 *      be alerted about, a test alert, and the recent alert log. Backed by the
 *      unified /api/vendor-alerts endpoints, the same panel every other vendor
 *      type mounts.
 *   2. In-app alert sound: the personal per-operator tone and volume.
 *
 * WHAT THIS SCREEN MAY PROMISE. No ticket-sale path reaches the vendor alert
 * dispatcher with NEW_ORDER, so an organizer gets email / SMS / WhatsApp for
 * changes to their organizer profile and for the test button, and nothing for a
 * ticket sale. The panel disables the "New orders" switch off the server's
 * `supportedEvents`; the copy here says the same thing, because a subtitle that
 * promised alerts "about ticket sales" was the part a reader believed.
 */

import React from "react";
import { Page, Hero, Panel, C } from "../theme/pbi";
import VendorAlertSettings from "../components/VendorAlertSettings";
import AlertSoundPrefs from "../components/AlertSoundPrefs";

const OrganizerAlerts = () => (
  <Page>
    <div style={{ padding: "16px 12px 0" }}>
      <Hero
        title="Alerts"
        subtitle="How Lusuku reaches you about changes to your organizer profile: email, SMS or WhatsApp, to the contacts you choose. Ticket sale alerts are not wired yet. Live ticket sales appear on your dashboard and in My Events."
      />
      <div style={{ maxWidth: 1040 }}>
        <Panel title="Alert settings" sub="email, SMS, WhatsApp" color={C.blue}>
          <VendorAlertSettings />
        </Panel>
        <Panel title="In-app alert sound" sub="this dashboard only" color={C.orange}>
          <AlertSoundPrefs />
        </Panel>
      </div>
    </div>
  </Page>
);

export default OrganizerAlerts;
